import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const { t } = useTranslation();

  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm">
      <Link
        to="/"
        className="text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
      >
        {t('breadcrumb.home')}
      </Link>
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
          {item.path ? (
            <Link
              to={item.path}
              className="text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800 font-medium whitespace-nowrap">
              {item.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
}